<template>
	<v-expansion-panel :expand="expand">
		<FaqAccordion
			v-for="faq in faqList"
			:key="faq.question"
			:question="faq.question"
			:answer="faq.answer"
		/>
	</v-expansion-panel>
</template>

<script>
import FaqAccordion from './FaqAccordion';

export default {
	name: 'Faq',
	components: { FaqAccordion },
	props: {
		expand: {
			type: Boolean,
			default: true
		},
		faqList: {
			type: Array,
			required: true,
			default: () => [
				{
					question: '',
					answer: ''
				}
			]
		}
	}
}
</script>

<style scoped></style>
